/**
 * fireCelebration — dispatches a celebration CustomEvent on the window
 */
export const fireCelebration = (type, { message, icon } = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('celebration', {
    detail: { ...type, message, icon },
  }));
};
